import { render, staticRenderFns } from "./f2g-chip.vue?vue&type=template&id=691eb07d&scoped=true"
import script from "./f2g-chip.vue?vue&type=script&lang=js"
export * from "./f2g-chip.vue?vue&type=script&lang=js"
import style0 from "./f2g-chip.vue?vue&type=style&index=0&id=691eb07d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691eb07d",
  null
  
)

export default component.exports